var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"tag":"button","to":_vm.target}},[_vm._v("Powrót do poprzedniej strony")])}
var staticRenderFns = []

export { render, staticRenderFns }